/*eslint-disable*/
import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import Hidden from "@material-ui/core/Hidden";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Icon from "@material-ui/core/Icon";
import Divider from "@material-ui/core/Divider";
import Typography from "@material-ui/core/Typography";
// core components
import AdminNavbarLinks from "components/Navbars/AdminNavbarLinks.js";
import RTLNavbarLinks from "components/Navbars/RTLNavbarLinks.js";

import styles from "assets/jss/material-dashboard-react/components/sidebarStyle.js";

const useStyles = makeStyles(styles);

const SECTION_ORDER = ["Inicio", "Catálogos", "Operaciones", "Consultas"];

export function groupRoutesBySection(routes) {
  const grouped = routes.reduce((acc, route) => {
    const section = route.seccion || "General";
    if (!acc[section]) acc[section] = [];
    acc[section].push(route);
    return acc;
  }, {});
  return grouped;
}

export function getSortedSections(groupedRoutes) {
  const keys = Object.keys(groupedRoutes);
  const sorted = [];
  SECTION_ORDER.forEach(section => {
    if (keys.includes(section)) sorted.push(section);
  });
  keys.forEach(section => {
    if (!sorted.includes(section)) sorted.push(section);
  });
  return sorted;
}

export default function Sidebar(props) {
  const classes = useStyles();

  // verifies if routeName is the one active (in browser input)
  function activeRoute(routeName) {
    return window.location.href.indexOf(routeName) > -1 ? true : false;
  }
  const { color, logo, image, logoText, routes } = props;

  const groupedRoutes = groupRoutesBySection(routes);
  const sortedSections = getSortedSections(groupedRoutes);

  const renderRouteItem = (prop, key) => {
    var listItemClasses = classNames({
      [" " + classes[color]]: activeRoute(prop.layout + prop.path)
    });
    const whiteFontClasses = classNames({
      [" " + classes.whiteFont]: activeRoute(prop.layout + prop.path)
    });

    const IconComponent = typeof prop.icon === 'function' || typeof prop.icon === 'object' ? prop.icon : null;

    return (
      <NavLink
        to={prop.layout + prop.path}
        className={classes.item}
        activeClassName="active"
        key={key}
      >
        <ListItem button className={classes.itemLink + listItemClasses}>
          {typeof prop.icon === "string" ? (
            <Icon
              className={classNames(classes.itemIcon, whiteFontClasses, {
                [classes.itemIconRTL]: props.rtlActive
              })}
            >
              {prop.icon}
            </Icon>
          ) : IconComponent ? (
            <IconComponent
              className={classNames(classes.itemIcon, whiteFontClasses, {
                [classes.itemIconRTL]: props.rtlActive
              })}
            />
          ) : null}
          <ListItemText
            primary={props.rtlActive ? prop.rtlName : prop.name}
            className={classNames(classes.itemText, whiteFontClasses, {
              [classes.itemTextRTL]: props.rtlActive
            })}
            disableTypography={true}
          />
        </ListItem>
      </NavLink>
    );
  };

  var links = (
    <List className={classes.list}>
      {sortedSections.map((section, sectionIndex) => (
        <React.Fragment key={section}>
          {sectionIndex > 0 && (
            <Divider className={classes.sectionDivider} />
          )}
          <Typography className={classes.sectionTitle}>
            {section}
          </Typography>
          {groupedRoutes[section].map((prop, key) =>
            renderRouteItem(prop, section + "-" + key)
          )}
        </React.Fragment>
      ))}
    </List>
  );

  var brand = (
    <div className={classes.logo}>
      <a
        href=""
        className={classNames(classes.logoLink, {
          [classes.logoLinkRTL]: props.rtlActive
        })}
      >
        <div className={classes.logoImage}>
          <img src={logo} alt="logo" className={classes.img} />
        </div>
        {logoText}
      </a>
    </div>
  );
  return (
    <div>
      <Hidden mdUp implementation="css">
        <Drawer
          variant="temporary"
          anchor={props.rtlActive ? "left" : "right"}
          open={props.open}
          classes={{
            paper: classNames(classes.drawerPaper, {
              [classes.drawerPaperRTL]: props.rtlActive
            })
          }}
          onClose={props.handleDrawerToggle}
          ModalProps={{
            keepMounted: true // Better open performance on mobile.
          }}
        >
          {brand}
          <div className={classes.sidebarWrapper}>
            {props.rtlActive ? <RTLNavbarLinks /> : <AdminNavbarLinks />}
            {links}
          </div>
          {image !== undefined ? (
            <div
              className={classes.background}
              style={{  }}
            />
          ) : null}
        </Drawer>
      </Hidden>
      <Hidden smDown implementation="css">
        <Drawer
          anchor={props.rtlActive ? "right" : "left"}
          variant="permanent"
          open
          classes={{
            paper: classNames(classes.drawerPaper, {
              [classes.drawerPaperRTL]: props.rtlActive
            })
          }}
        >
          {brand}
          <div className={classes.sidebarWrapper}>{links}</div>
          {image !== undefined ? (
            <div
              className={classes.background}
              style={{  }}
            />
          ) : null}
        </Drawer>
      </Hidden>
    </div>
  );
}

Sidebar.propTypes = {
  rtlActive: PropTypes.bool,
  handleDrawerToggle: PropTypes.func,
  bgColor: PropTypes.oneOf(["purple", "blue", "green", "orange", "red", "teal"]),
  logo: PropTypes.string,
  image: PropTypes.string,
  logoText: PropTypes.string,
  routes: PropTypes.arrayOf(PropTypes.object),
  open: PropTypes.bool
};
